module.exports = __webpack_public_path__ + "img/1853.f4981987.gif";